import NotificationMixin from './NotificationMixin';

export default {
  mixins: [NotificationMixin],
  methods: {
    serviceCall(request, cb, messageError, ...rest) {
      const { cbFinally, valueKey } = this.getSetRestProps(rest);
      request
        .then(this.successCallBack(cb, valueKey))
        .catch(this.erroCallBack(messageError))
        .finally(() => {
          if (cbFinally) {
            cbFinally();
          }
        });
    },
    getSetRestProps(rest = []) {
      let valueKey = 'id';
      let cbFinally;

      rest.forEach((prop) => {
        if (prop && typeof prop === 'string') {
          valueKey = prop;
        } else if (prop && typeof prop === 'function') {
          cbFinally = prop;
        }
      });

      return {
        valueKey,
        cbFinally,
      };
    },
    successCallBack(cb, valueKey = 'id') {
      return ({ data }) => {
        cb(
          this.prepareData(data),
          valueKey,
        );
      };
    },
    prepareData(data) {
      if (data) {
        if (data.content) {
          return data.content;
        }
        return Array.isArray(data.data)
          ? data.data
          : [data];
      }
      return data;
    },
    erroCallBack(message) {
      return ({ response }) => {
        this.showMessageError(response, message);
      };
    },
    showMessageError(response, message) {
      this.showErrorToast(
        this.setMessageError(response, message),
      );
    },
    setMessageError(response, messageError) {
      let message = messageError;

      if (this.hasMessageError(response)) {
        message = response.data.message;
      }

      return {
        text: message,
      };
    },
    hasMessageError(err) {
      return err
        && err.response
        && err.response.data
        && err.response.data.message;
    },
    setDataOptions(dataName, ...options) {
      return (data, valueKey = 'id') => {
        this[dataName] = data.map(
          (item) => this.makeSelectContent(item, valueKey, options),
        );
      };
    },
    makeSelectContent(item, valueKey, options = []) {
      return {
        value: this.getItemProperty(valueKey.split('.'), item),
        text: this.getItemProperty(options, item),
        item,
      };
    },
    getItemProperty(options = [], item) {
      let text = '';
      if (options.length > 1) {
        let value;
        options.forEach((key) => {
          value = value ? value[key] : item[key];
        });
        text = value;
      } else {
        text = item[options];
      }
      return text;
    },
    makeParams(defaultParams = {}) {
      return {
        Page: 1,
        PerPage: 1000,
        ...defaultParams,
      };
    },
    hasData(response) {
      return response && response.data;
    },
  },
};
